import { Link } from "react-router-dom";
import bim from "./images/LOGO SISTEMA MUSEALE PICENO.png";
import css from "./Footer.module.css";

export default function Footer() {
  return (
    <>
      <div className="container">
        <footer className="py-3 my-4 mt-auto">
          <ul className="nav justify-content-center border-bottom pb-3 mb-3">
            <li className="nav-item">
              <Link to={"/"} className="nav-link px-2 text-muted">
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link to={"/museo"} className="nav-link px-2 text-muted">
                Scopri
              </Link>
            </li>
            <li className="nav-item">
              <Link to={"/visita"} className="nav-link px-2 text-muted">
                Visita
              </Link>
            </li>
            <li className="nav-item">
              <Link to={"/antonio-orsini"} className="nav-link px-2 text-muted">
                Orsini
              </Link>
            </li>
          </ul>
          <p className="text-center text-muted">
            &copy; {new Date().getFullYear().toString()} Museo di Storia
            Naturale A. Orsini
          </p>
          <div className="text-center">
            <img
              src={bim}
              alt="Sistema Museale Piceno"
              style={{ width: "80px" }}
            />
          </div>
          <div className="row pt-4">
            <div className="col d-flex justify-content-center justify-content-lg-end">
              <p className="m-0">
                <a
                  className={css["poweredBy"]}
                  href="https://www.knowaysystems.it/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <em>Powered by Knoway Systems srl</em>
                </a>
              </p>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}
